import { Link } from 'react-router-dom';
import { Wordmark } from './Wordmark';

interface SharedFooterProps {
  className?: string;
  variant?: 'default' | 'dark';
}

export function SharedFooter({ className = '', variant = 'default' }: SharedFooterProps) {
  const isDark = variant === 'dark';
  const footerClassName = isDark
    ? `border-t border-white/10 bg-[#0a0908] py-12 ${className}`
    : `border-t border-line-soft py-12 ${className}`;
  const headingClassName = isDark
    ? 'font-display text-[12px] text-white/80 mb-4'
    : 'font-display text-[12px] text-text mb-4';
  const linkClassName = isDark
    ? 'text-[13.5px] text-white/45 hover:text-white/80 transition-colors'
    : 'text-[13.5px] text-text-dim hover:text-text transition-colors';

  return (
    <footer className={footerClassName.trim()}>
      <div className="page-container">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Wordmark asLink={false} className={isDark ? 'text-white/85' : ''} />
          </div>
          <div>
            <h5 className={headingClassName}>Product</h5>
            <ul className="space-y-2.5">
              <li><Link to="/models/apply" className={linkClassName}>Apply to Model</Link></li>
            </ul>
          </div>
          <div>
            <h5 className={headingClassName}>Community</h5>
            <ul className="space-y-2.5">
              <li><Link to="/code-of-conduct" className={linkClassName}>Code of Conduct</Link></li>
              <li><Link to="/models" className={linkClassName}>Models</Link></li>
              <li><Link to="/artists" className={linkClassName}>Artists</Link></li>
              <li><Link to="/studios" className={linkClassName}>Studios</Link></li>
            </ul>
          </div>
          <div>
            <h5 className={headingClassName}>The fine print</h5>
            <ul className="space-y-2.5">
              <li><Link to="/about" className={linkClassName}>About</Link></li>
              <li><Link to="/privacy" className={linkClassName}>Privacy</Link></li>
              <li><Link to="/terms" className={linkClassName}>Terms</Link></li>
              <li><Link to="/report-a-concern" className={linkClassName}>Report a concern</Link></li>
              <li><Link to="/contact" className={linkClassName}>Contact</Link></li>
            </ul>
          </div>
        </div>
        <div className={`mt-10 pt-5 border-t font-display text-[11px] ${isDark ? 'border-white/10 text-white/35' : 'border-line-soft text-text-faint'}`}>
          <span>© 2026 LifeDrawing.live</span>
        </div>
      </div>
    </footer>
  );
}
